export default __webpack_public_path__ + "static/media/list.27a44f5e.svg";